import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const ACTION_COLORS = {
  login_success: "text-[#519872]",
  login_failed: "text-[#9b1f2c]",
  login_denied: "text-[#9b1f2c]",
  logout: "text-[#6B7280]",
  bootstrap_owner_created: "text-[#7A4986]",
  user_invited: "text-[#7A4986]",
  user_updated: "text-[#1f5d80]",
  user_removed: "text-[#9b1f2c]",
  group_created: "text-[#519872]",
  group_updated: "text-[#1f5d80]",
  group_archived: "text-[#9b1f2c]",
  price_changed: "text-[#7A4986]",
  lead_payment_resent: "text-[#1f5d80]",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setLogs(r.data)).catch(() => toast.error("Audit log indisponibil"));
  }, []);

  return (
    <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-x-auto" data-testid="audit-log">
      <table className="w-full min-w-[900px] text-sm">
        <thead className="bg-[#EDEEF0] text-[#373A45]">
          <tr className="text-left">
            <Th>Data</Th><Th>Acțiune</Th><Th>Actor</Th><Th>Țintă</Th><Th>IP</Th><Th>Detalii</Th>
          </tr>
        </thead>
        <tbody>
          {logs.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-[#6B7280]">Niciun eveniment înregistrat.</td></tr>}
          {logs.map((l) => (
            <tr key={l.id} className="border-t border-[#E5E7EB]">
              <Td className="text-[#6B7280] text-xs">{new Date(l.ts).toLocaleString("ro-RO")}</Td>
              <Td>
                <span className={`text-xs font-semibold ${ACTION_COLORS[l.action] || "text-[#373A45]"}`}>
                  {l.action}
                </span>
              </Td>
              <Td className="text-xs">{l.actor_email || "—"}</Td>
              <Td className="text-xs">{l.target_email || "—"}</Td>
              <Td className="text-[11px] text-[#6B7280]">{l.ip || "—"}</Td>
              <Td className="min-w-[320px] max-w-[560px]">
                <AuditDetails details={l.details} />
              </Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Details as "key: value" lines that wrap, so long ids and dates are read
 * in full instead of running off the edge of the table. */
export function detailLines(details) {
  if (!details || typeof details !== "object") return [];
  return Object.entries(details).map(([key, value]) => [
    key,
    value === null || value === undefined ? "—" : typeof value === "object" ? JSON.stringify(value) : String(value),
  ]);
}

function AuditDetails({ details }) {
  const lines = detailLines(details);
  if (!lines.length) return <span className="text-[11px] text-[#6B7280]">—</span>;
  return (
    <dl className="grid grid-cols-[auto,1fr] gap-x-2 gap-y-0.5 font-mono text-[11px] leading-snug" data-testid="audit-details">
      {lines.map(([key, value]) => (
        <React.Fragment key={key}>
          <dt className="whitespace-nowrap text-[#6B7280]">{key}:</dt>
          <dd className="select-all break-all text-[#373A45]">{value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

const Th = ({ children }) => <th className="px-4 py-3 text-xs uppercase tracking-widest font-semibold">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-4 py-3 text-[#373A45] align-top ${className}`}>{children}</td>;
